import React from 'react';
import FolderOpen from '@material-ui/icons/FolderOpen';

const DomainIcon = ({ color }) => <FolderOpen style={{ color }} />;

export default DomainIcon;
